import React from "react";
import { observer } from "mobx-react";
import { FacilityMissingDocsSearchTemplate } from "themes/application/facility-missing-docs/pages";
import { FacilityMissingDocsSearchViewStore } from "application/facility-missing-docs/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityMissingDocsSearchViewStore(rootStore), "facilityMissingDocsSearchViewStore")
@observer
class FacilityMissingDocsSearch extends React.Component {
	render() {
		return <FacilityMissingDocsSearchTemplate {...this.props} />;
	}
}

export default FacilityMissingDocsSearch;